import React from "react";
import styled from "styled-components";
import { Line } from "react-chartjs-2";
import { Icon } from "@/shared/components/Icon";

const ChartCard = styled.div`
	width: 100%;
	background: #fafafa;
	border-radius: 8px;
	padding: 24px;
	margin-top: 24px;
	box-shadow: 0px 4px 4px rgba(58, 12, 163, 0.06);
	display: flex;
	flex-direction: column;
	gap: 24px;
`;

const ChartHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
`;

const ChartTitleText = styled.div`
	font-size: 20px;
	font-weight: 700;
	color: #454545;
	font-family: "Poppins", sans-serif;
`;

const ChartSubNotice = styled.div`
	display: flex;
	gap: 8px;
	align-items: center;
	color: #858585;
	font-size: 14px;
	font-family: "Poppins", sans-serif;
`;

const DataNoticeIcon = styled(Icon)`
	width: 16px;
	height: 16px;
`;

const ChartLegend = styled.div`
	display: flex;
	gap: 40px;
	align-items: center;
`;

const LegendItem = styled.div`
	display: flex;
	gap: 8px;
	align-items: center;
	font-size: 14px;
	color: #454545;
	font-family: "Poppins", sans-serif;
`;

const LegendColor = styled.div<{ $color: string }>`
	width: 16px;
	height: 16px;
	border-radius: 40px;
	background: ${(props) => props.$color};
`;

interface PerformanceChartProps {
	data: any;
	options: any;
}

export const PerformanceChart: React.FC<PerformanceChartProps> = ({ data, options }) => {
	return (
		<ChartCard>
			<ChartHeader>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						gap: "16px",
					}}
				>
					<ChartTitleText>Views and Engagement Over Time</ChartTitleText>
					<ChartSubNotice>
						<DataNoticeIcon name="info" alt="Info" />
						Hour of the day (Sydney, Australia, GMT+11)
					</ChartSubNotice>
				</div>
				<ChartLegend>
					<LegendItem>
						<LegendColor $color="#3A0CA3" />
						Views
					</LegendItem>
					<LegendItem>
						<LegendColor $color="#F72586" />
						Engagements
					</LegendItem>
				</ChartLegend>
			</ChartHeader>
			<div style={{ width: "100%", height: 340 }}>
				<Line data={data} options={options} />
			</div>
		</ChartCard>
	);
};
